import React from "react";
import TutoringInbox from "./TutoringInbox";
import * as api from "../../../apis/Tutoring";

// HQ admin scope — sees all threads across branches.
const getUserId = () => {
  try {
    return JSON.parse(localStorage.getItem("userData"))?.data?.id;
  } catch {
    return null;
  }
};

const adminApi = {
  listThreads: (params) => api.tutoring_threads(params),
  getThread: (id) => api.tutoring_thread(id),
  reply: ({ thread_id, body, attachment_url }) =>
    api.tutoring_reply({ thread_id, body, attachment_url, user_id: getUserId() }),
  setStatus: (id, status) => api.tutoring_thread_status(id, status),
  uploadAttachment: (file) => api.upload_attachment(file),
};

const AdminTutoring = () => <TutoringInbox api={adminApi} scope="admin" />;

export default AdminTutoring;
